import { renderers } from './renderers.js';

export const cityMapper = {
  renderers,
  nextId: 0,
};
